import { render, staticRenderFns } from "./CustomersOverview.vue?vue&type=template&id=3272a4cd&"
import script from "./CustomersOverview.vue?vue&type=script&lang=js&"
export * from "./CustomersOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports